// src/utils/supabase/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.GATSBY_SUPABASE_URL;
const supabaseAnonKey = process.env.GATSBY_SUPABASE_ANON_KEY;

const DEV = process.env.NODE_ENV !== "production";

if ((!supabaseUrl || !supabaseAnonKey) && DEV) {
  throw new Error(
    "[supabase] Missing GATSBY_SUPABASE_URL or GATSBY_SUPABASE_ANON_KEY"
  );
}
 
export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          storageKey: "supabase.auth.token",
        },
      })
    : null;